import { u_ } from "@pressmedia/webappbase";

export default {
	/**
	* ajax シート遷移処理
	* 確認画面用シートでは「登録・更新リクエスト」を投げ、そこまでは成功コールバックにて「次のシー
	* トを表示」する処理を行う。※確認画面用シートにconfirmクラスが記述されている必要アリ。
	* @param {Function | Object} opt: オプション項目（シート種別による開始＆成功コールバック）
	*/
	async aNextStep(opt) {
		if(!this.getSheet().length) {
			throw new Error("this form has no sheets.");
		}
		
		u_.isObject(opt) || (opt = {});
		opt = { ...this.nextStepCallBacks, ...opt };
		
		const activeSheet = this.getActiveSheet();
		let doRequest = false;
		
		if(activeSheet) {
			if(this.confirmSheetName) {
				// 確認シートありの場合
				if(activeSheet.name === this.confirmSheetName) {
					// 確認シートがアクティブであれば実行リクエストを行う
					doRequest = true;
				}
			} else
			if(activeSheet.name === Object.keys(this.config.sheet).slice(-1)[0]) {
				// 確認シートなしの場合、最後の入力シートがアクティブであれば実行リクエストを行う
				doRequest = true;
			}
		}
		
		if(doRequest) {
			// confirm sheet is active.
			return this.aRequestExec({
				allSheets: true,
				begin: opt.beforeRequestEdit,
				async success(res) {
					const r = await opt.editedResponce.call(this, res);
					if(r !== false && this.finishSheetName) {
						// 次のシートをアクティブに
						return this.setActiveSheet(this._activeSheetIdx + 1);
					}
				}
			});
			
		} else {
			return this.aRequestConfirm({
				begin: opt.beforeRequestNext,
				async success(res) {
					const r = await opt.beforeFocusNext.call(this, res);
					if(r !== false) {
						// 次のシートをアクティブに
						await this.setActiveSheet(this._activeSheetIdx + 1)
						return opt.afterFocusNext();
					}
				}
			});
		}
	}
};
